import React from "react";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a
          href="https://api.whatsapp.com/send?phone=9779847112497"
          target={"_blank"}
          rel="noreferrer"
        >
          <BsWhatsapp />
        </a>
      </div>
      <div>
        <a
          href="https://www.instagram.com/ccir.g/?hl=en"
          target={"_blank"}
          rel="noreferrer"
        >
          <BsInstagram />
        </a>
      </div>
      <div>
        <a
          href="https://www.facebook.com/ccir.gaire/"
          target={"_blank"}
          rel="noreferrer"
        >
          <FaFacebookF />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
